import { render, staticRenderFns } from "./QrCode3.vue?vue&type=template&id=28d594fe&scoped=true&"
import script from "./QrCode3.vue?vue&type=script&lang=js&"
export * from "./QrCode3.vue?vue&type=script&lang=js&"
import style0 from "./QrCode3.vue?vue&type=style&index=0&id=28d594fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d594fe",
  null
  
)

export default component.exports